'use strict';

var { uniq } = require('underscore'),
    getAllStampImages = require('./getAllStampImages');

function getUniqueStampImages(stamp) {
  return uniq(getAllStampImages(stamp), image => image.url);
}

module.exports = getUniqueStampImages;


/** WEBPACK FOOTER **
 ** ./utils/getUniqueStampImages.js
 **/